import gql from 'graphql-tag';
import fragments from 'utils/graphql/fragments';

export const QUERY_GET_USERS_CURRENTLY_PLAYING_GAME = gql`
  query GetUsersCurrentlyPlayingGame(
    $input: GetUsersCurrentlyPlayingGameInput!
  ) {
    getUsersCurrentlyPlayingGame(input: $input) {
      users {
        ...UserIdAndDisplayFields
      }
      count
    }
  }
  ${fragments.userIdAndDisplay}
`;

export const SUBSCRIPTION_ADD_USER_CURRENTLY_PLAYING_GAME = gql`
  subscription AddUserCurrentlyPlayingGame(
    $input: UserCurrentlyPlayingGameInput!
  ) {
    addUserCurrentlyPlayingGame(input: $input) {
      user {
        ...UserIdAndDisplayFields
      }
    }
  }
  ${fragments.userIdAndDisplay}
`;

export const SUBSCRIPTION_REMOVE_USER_CURRENTLY_PLAYING_GAME = gql`
  subscription RemoveUserCurrentlyPlayingGame(
    $input: UserCurrentlyPlayingGameInput!
  ) {
    removeUserCurrentlyPlayingGame(input: $input) {
      user {
        ...UserIdAndDisplayFields
      }
    }
  }
  ${fragments.userIdAndDisplay}
`;
